import template from "./calendarIconElement.hbs";
import "./calendarIconElement.scss";

export class CalendarIconElement extends HTMLElement {

  private _readOnly: boolean;

  constructor() {
    super();
    this.innerHTML = template({});
    this.bindEvents();
  }

  private bindEvents(): void {

    this.addEventListener("click", (e) => {
      if (this._readOnly) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
  }

  public set readOnly(ro: boolean) {
    this._readOnly = ro;
    if (ro) {
      this.style.color = "#bbb";
    } else {
      this.removeAttribute("style");
    }
  }
}

export function initCalendarIconWebComponent() {
  window.customElements.define("s6-date-calendar-icon", CalendarIconElement);
}
